import { all, call } from 'redux-saga/effects'
import { routinePromiseWatcherSaga } from 'redux-saga-routines'
import { userSagas } from 'ducks/user/sagas'
import { SagaIterator } from 'redux-saga'
import { businessApiSagas } from 'ducks/businessApi'

export const createSagasTrigger = <T>(actionType: string) => ({
  trigger: actionType,
  run: (payload: T) => ({
    type: actionType,
    payload,
  }),
})

export default function* rootSaga(): SagaIterator {
  try {
    yield all([call(routinePromiseWatcherSaga), call(userSagas), call(businessApiSagas)])
  } catch {
    // handle error here
  }
}
